import styled from "styled-components";

import color from "constants/color";

const Label = styled.span<{ category: AtPortSystemNotificationSummary["category"] }>`
  font-weight: bold;
  color: ${({ category }) => {
    switch (category) {
      case "アップデート情報":
        return `${color.atPort}`;
      case "メンテナンス情報":
        return `${color.attention}`;
      case "障害対応":
        return `${color.warning}`;
      default:
        return `${color.text.gray}`;
    }
  }};
`;

const NotificationCategorySwitcher = ({ category }: { category: AtPortSystemNotificationSummary["category"] }) => {
  return <Label category={category}>{category}</Label>;
};

export default NotificationCategorySwitcher;
